import { NgModule } from '@angular/core';
import { DashboardDataService, WidgetDashboardDataService } from '../services';

@NgModule({
  providers: [WidgetDashboardDataService, DashboardDataService],
})
export class DashboardEntityStoreModule {}
